import React, { useState, useEffect } from "react";
import { Logo } from "../../constant/Index";
import "../../assets/Css/forgot.css";
import { Link, useNavigate } from "react-router-dom";
import { useUserForgetPassMutation } from "../../store/services/AuthServices";
import { ToastMessage } from "../../utils/ShowToastMessage";
import { clearMessage, setSuccess } from "../../store/reducers/globalReducers";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "../../hooks/Form";

const ForgotPassword = () => {
	const [errors, setErrors] = useState([]);
	const { state, onChange } = useForm({
		email: "",
	});
	const dispatch = useDispatch();
	const navigate = useNavigate();

	let { success } = useSelector((state) => state.globalReducer);

	const [userForgetData, response] = useUserForgetPassMutation();
	const onSubmit = (e) => {
		e.preventDefault();
		const FormDatas = new FormData();
		FormDatas.append("email", state.email);
		userForgetData(FormDatas);
	};

	useEffect(() => {
		if (success !== "") {
			ToastMessage(success);
		}
		return () => {
			dispatch(clearMessage());
		};
	}, [success]);

	useEffect(() => {
		if (response.isError) {
			setErrors(response?.error?.data?.errors);
		}
	}, [response?.error?.data]);

	useEffect(() => {
		if (response.isSuccess) {
			setErrors([]);
			dispatch(setSuccess(response?.data?.message));
			state.email = "";

		}
	}, [response.isSuccess]);
	return (
		<>
			{/* <!-- Sign In Page Start Here --> */}
			<section className="signinSec ForgotPassword  p-0 ">
				<div className="container-fluid">
					<div className="row align-items-center">
						<div className="col-lg-4"></div>
						<div className="col-lg-4 p-0">
							<div className="logo-wrapper">
								<Link to="/">
									{" "}
									<figure>
										<img src={Logo} alt="" />
									</figure>
								</Link>
							</div>
							<div className="signInBox">
								<div className="title">
									<h1>Forgot Password</h1>
								</div>

								<div className="taglines pb-3">
									<h3>Enter Your email to recover your account</h3>
								</div>
								<form onSubmit={onSubmit}>
									<div className="form-group">
										<input
											type="email"
											placeholder="Enter Your Email"
											className={`${
												errors && errors?.email
													? "SetErrorshow form-control"
													: "form-control"
											}`}
											name="email"
											value={state.email}
											onChange={onChange}
										/>
									</div>
									{errors && errors?.email && (
										<span className="errorMessage">
											<p>{errors && errors?.email}</p>
										</span>
									)}
									<div className="col-md-12 px-0 text-right mt-3">
										<button
											className="btn btn-secondary btnn signup-btn rounded-pill full"
											type="submit"
										>
											Submit
										</button>
									</div>
									<div className="privacyDv">
										<p>Copyrights © 2022 EVX. All rights reserved.</p>
									</div>
								</form>
							</div>
						</div>
						<div className="col-lg-4"></div>
					</div>
				</div>
			</section>
			{/* <!-- Sign In Page End Here --> */}
		</>
	);
};

export default ForgotPassword;
